import googleAnalytics from './includes/google-analytics'

require('jquery-ui/themes/base/slider.css');
require('./../scss/assortment22.scss');
require('./../scss/assortment_filter.scss');
require('jquery-ui/ui/widgets/slider');

import Util from './Util';
import { respondToVisibility } from './Util';

import TextContent from './components/text_content.js'
import CharityProduct from './components/CharityProduct.js'

const APP = window.APP

let assortment = new function () {};

assortment.init = function () {
    APP.banner.leftTop();
    new TextContent()
    new CharityProduct()
    assortment.bindEvents();
};

function handleGoogleAnalyticsProductImpressions() {
    const productItems = document.getElementsByClassName('product-item')
    productItems.forEach((item, index) => {
        respondToVisibility(item, (impression) => {
            if (item.dataset.dataLayer) {
                const dataLayer = JSON.parse(item.dataset.dataLayer)
                dataLayer.position = index + 1
                if (impression) {
                    googleAnalytics.productImpression(item, dataLayer)
                }
            }
        }, true)
    })
}

assortment.bindEvents = function () {
    handleGoogleAnalyticsProductImpressions()

    const filterToggle = document.querySelector('.filter-toggle');
    const product = $('.producthover');

    if (filterToggle !== null) {
        filterToggle.addEventListener('click', function () {
            const filter = document.querySelector('.filter');
            filter.classList.toggle('filter--visible');
        });
    }

    product.on('mouseenter mouseleave', function (e) {
        if ($(window).width() < 992) {
            return false;
        }

        switch (e.type) {
            case 'mouseenter':
                const productItemClone = $(this).find('.product-item').clone(true);

                $(productItemClone).addClass('product-item-clone');
                $(productItemClone).insertAfter($(this).find('.product-item'));

                break;
            case 'mouseleave':
                $(this).find('.product-item-clone').remove();

                break;
        }
    });

    const minAmount = $('#min-amount');
    const maxAmount = $('#max-amount');
    const sliderRange = $('#slider-range');

    sliderRange.slider({
        range: true,
        min: parseInt(sliderRange.attr('data-min-price')),
        max: parseInt(sliderRange.attr('data-max-price')) + 1,
        values: [0, 100],
        slide: function (event, ui) {
            let firstVal = parseInt(ui.values[0]);
            let secondVal = parseInt(ui.values[1]);
            minAmount.val(firstVal);
            maxAmount.val(secondVal);

            minAmount.trigger('change');
            maxAmount.trigger('change');
        }
    });

    let firstVal = sliderRange.slider('values', 0);
    let secondVal = sliderRange.slider('values', 1);
    minAmount.val(firstVal);
    maxAmount.val(secondVal);

    minAmount.on('change', function (e) {
        let firstVal = $(this).val();
        sliderRange.slider('values', 0, firstVal);

        filterProducts();
    });

    maxAmount.on('change', function (e) {
        let secondVal = $(this).val();
        sliderRange.slider('values', 1, secondVal);

        filterProducts();
    });

    const filterCheckLabel = $('.filter__label');

    filterCheckLabel.on('click', function (e) {
        e.preventDefault();
        const input = $(this).prev();
        input.prop('checked', !input.prop('checked'));

        filterProducts();
    });

    function filterProducts() {
        product.hide().removeClass('filtered');
        const checkedInputs = $('.filter__input:checked');
        let filtered = false;

        let filters = {};
        let i = 0;

        checkedInputs.each(function () {
            const input = $(this);
            if (input.prop('checked')) {
                filtered = true;
                const inputVal = input.val();
                const filterArray = inputVal.split('-');
                if (typeof filters[filterArray[0]] === typeof undefined) {
                    filters[filterArray[0]] = [];
                }

                filters[filterArray[0]].push(inputVal);
                i++;
            }
        });

        if (!filtered) {
            product.show();
        } else {
            let filterCombinations = Util.cartesian(filters);
            $.each(filterCombinations, function (index, combination) {
                let filteredProduct = '';
                $.each(combination, function (key, filter) {
                    filteredProduct += '.filter-' + filter;
                });

                $(filteredProduct).addClass('filtered').show();
            });
        }

        product.filter(function () {
            return parseFloat($(this).data('product-price')) < parseInt(minAmount.val())
                || parseFloat($(this).data('product-price')) > parseInt(maxAmount.val());
        }).hide();

        product.filter(function () {
            if (filtered && !$(this).hasClass('filtered')) {
                return false;
            }
            return parseFloat($(this).data('product-price')) > parseInt(minAmount.val())
                && parseFloat($(this).data('product-price')) < parseInt(maxAmount.val());
        }).show();


        filterCheckLabel.each(function () {
            const id = $(this).prev().attr('id').replace('check-', '');
            const filteredProduct = $(`.producthover.filter-${id}:visible`);

            $(this).find('.filter-count').html(filteredProduct.length);
        });
    }
};

$(function() {
    assortment.init();
});
